/** Lifecycle helpers of the project workflow (lot L3). */
import type { PersonRef, Project, ProjectStatus, StatusChange } from '../../../types/projects';

/** The five milestones of the lifecycle, in order (« analysing » is step 2 pending). */
export const LIFECYCLE_STEPS = ['deposited', 'analysed', 'proposed', 'reviewing', 'qualified'] as const;
export type LifecycleStep = (typeof LIFECYCLE_STEPS)[number];

/** 0-based milestone reached by each status. */
export const STATUS_STAGE: Record<ProjectStatus, number> = {
  deposited: 0,
  analysing: 1,
  analysed: 1,
  proposed: 2,
  reviewing: 3,
  qualified: 4,
};

/** Statuses past the proposal: the portfolio managers have the project in hand. */
export const isInReview = (status: ProjectStatus): boolean =>
  status === 'proposed' || status === 'reviewing' || status === 'qualified';

/** The last time the project entered `status` (a project can go back to « En revue »). */
export function reachedAt(history: StatusChange[] | null | undefined, status: ProjectStatus): StatusChange | undefined {
  if (!history) return undefined;
  for (let i = history.length - 1; i >= 0; i -= 1) if (history[i].status === status) return history[i];
  return undefined;
}

export const qualificationPath = (id: string): string => `/projets/${id}/qualifier`;

export const personName = (p?: PersonRef | null): string => p?.name || p?.email || '';

/** Same author: by id when both have one (the list carries ids). */
export const isAuthoredBy = (p: Project, author?: PersonRef | null): boolean => !!author?.id && p.author?.id === author.id;
